module.exports = __webpack_public_path__ + "img/yibao-logo.36010fa6.png";